import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectBuyerProjectManagerUpdating,
  selectOperatorProjectManagerUpdating,
  selectCreatingPriceBlock,
  selectPriceBlockError,
  selectResettingFusionBlockStats,
  selectFusionBlockResetError,
  selectFusionStats,
  selectFusionStatsLoading,
  selectFusionStatsError,
} from './survey-management.selectors';

@Injectable({ providedIn: 'root' })
export class SurveyManagementSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly buyerProjectManagerUpdating = this._store.selectSignal(
    selectBuyerProjectManagerUpdating,
  );
  public readonly operatorProjectManagerUpdating = this._store.selectSignal(
    selectOperatorProjectManagerUpdating,
  );
  public readonly creatingPriceBlock = this._store.selectSignal(
    selectCreatingPriceBlock,
  );
  public readonly priceBlockError = this._store.selectSignal(
    selectPriceBlockError,
  );
  public readonly resettingFusionBlockStats = this._store.selectSignal(
    selectResettingFusionBlockStats,
  );
  public readonly fusionBlockResetError = this._store.selectSignal(
    selectFusionBlockResetError,
  );
  public readonly fusionStats = this._store.selectSignal(selectFusionStats);
  public readonly fusionStatsLoading = this._store.selectSignal(
    selectFusionStatsLoading,
  );
  public readonly fusionStatsError = this._store.selectSignal(
    selectFusionStatsError,
  );
}
